import api from 'lib/trpcClient';

const useInvestmentUploadV2 = () => {
  const validate =
    api.investorInvestmentUpload.validateAndPreview.useMutation();
  const identityLookup =
    api.investorInvestmentUpload.lookupIdentity.useMutation();

  return {
    validate,
    identityLookup,
  };
};

export default useInvestmentUploadV2;
